import React from 'react';
import { useSystemGeneralSettings } from '../hooks/use-system-general-settings.js';
import SystemGeneralSettingsPageView from './system-general-settings-page-view.jsx';

function SystemGeneralSettingsPageContainer({ mode = 'general' }) {
  const state = useSystemGeneralSettings();
  return <SystemGeneralSettingsPageView {...state} mode={mode} />;
}

export default SystemGeneralSettingsPageContainer;
